/**
 * 底部按钮栏，支持双按钮、单确认按钮或单取消按钮
 */
import './index.scss';

import { Button } from 'vant';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'ButtonBar' })
export default class ButtonBar extends Vue {
  @Prop(String)
  private cancelText!: string; // 不为空时显示取消按钮

  @Prop(String)
  private confirmText!: string; // 不为空时显示确认按钮

  @Prop({
    type: Boolean,
    default: false,
  })
  private disabled!: boolean; // 确认按钮的disabled属性

  @Prop({
    type: Boolean,
    default: false,
  })
  private noBorder!: boolean;

  @Prop({ default: true })
  private iphoneButtonBar!: boolean;

  // 是否新版底部按钮样式
  @Prop({ default: false })
  readonly isNewBtnType!: boolean

  private onCancel() {
    this.$emit('cancel');
  }

  private onConfirm() {
    this.$emit('confirm');
  }

  private render() {
    return (
      <div
        class={['ButtonBar', this.cancelText && this.confirmText && 'doubleButton', this.isNewBtnType && 'newTypeBtn']}
        style={{ boxShadow: this.noBorder ? 'none' : undefined }}
      >
        {this.cancelText && (
          <Button
            type="plain"
            onClick={this.onCancel.bind(this)}
            class={this.iphoneButtonBar && 'button_padding'}
          >
            {this.cancelText}
          </Button>
        )}

        {this.confirmText && (
          <Button
            type="primary"
            disabled={this.disabled}
            class={['confirm_button', this.iphoneButtonBar && 'button_padding']}
            onClick={this.onConfirm.bind(this)}
          >
            {this.confirmText}
          </Button>
        )}
      </div>
    );
  }
}
